import HeroSection from "./components/HeroSection";
import FocusRank from "./components/FocusRank";
import CategoryGrid from "./components/CategoryGrid";
import MomentsGrid from "./components/MomentsGrid";
import JudgeWall from "./components/JudgeWall";
import TimelineSection from "./components/TimelineSection";
import TestimonialSection from "./components/TestimonialSection";
import FaqSection from "./components/FaqSection";
import NewsletterSection from "./components/NewsletterSection";
import JsonLd from "@/components/feature/JsonLd";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { site } from "@/mocks/site";
import { faqs } from "@/mocks/faqs";
import { articles } from "@/mocks/articles";

const BASE = "https://kdove.cn";

export default function Home() {
  useDocumentMeta({
    title: "吃瓜前排｜选美翻车现场与搞笑名场面盘点",
    description:
      "围观选美吃瓜翻车现场，盘点淘汰尴尬瞬间、即兴失误与搞笑名场面。从评委表情到选手反应，选美吃瓜乐子一次看够。",
    keywords: "选美吃瓜,选美吃瓜翻车,选美现场名场面,选美尴尬瞬间,选美搞笑名场面",
    canonical: `${BASE}/`,
  });

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: site.brand,
      url: `${BASE}/`,
      description: site.description,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${BASE}/category/fails?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: site.brand,
      url: `${BASE}/`,
      email: site.email,
      slogan: site.slogan,
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "本季焦点翻车榜",
      itemListElement: articles.slice(0, 5).map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `${BASE}/article/${item.id}`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    },
  ];

  return (
    <>
      <JsonLd data={structuredData} />
      <HeroSection />
      <FocusRank />
      <CategoryGrid />
      <MomentsGrid />
      <JudgeWall />
      <TimelineSection />
      <TestimonialSection />
      <FaqSection />
      <NewsletterSection />
    </>
  );
}